// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Logo-logoColor-am5Gl,
.Logo-logoColor-am5Gl:hover,
.Logo-logoColor-am5Gl:focus {
	color: var(--common-link-color);
	font-size: 18px;
	line-height: 28px;
	font-weight: 500;
}

.Logo-logoColor-am5Gl {
	text-decoration: none;
}

.Logo-logoColor-am5Gl:hover,
.Logo-logoColor-am5Gl:focus {
	text-decoration: underline;
}

.Logo-whiteColor-zLPH3 {
	color: var(--primary-white-foreground);
}`, "",{"version":3,"sources":["webpack://./src/components/Logo/Logo.css"],"names":[],"mappings":"AAAA;;;CAGC,+BAA+B;CAC/B,eAAe;CACf,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;;CAEC,0BAA0B;AAC3B;;AAEA;CACC,sCAAsC;AACvC","sourcesContent":[".logoColor,\n.logoColor:hover,\n.logoColor:focus {\n\tcolor: var(--common-link-color);\n\tfont-size: 18px;\n\tline-height: 28px;\n\tfont-weight: 500;\n}\n\n.logoColor {\n\ttext-decoration: none;\n}\n\n.logoColor:hover,\n.logoColor:focus {\n\ttext-decoration: underline;\n}\n\n.whiteColor {\n\tcolor: var(--primary-white-foreground);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logoColor": `Logo-logoColor-am5Gl`,
	"whiteColor": `Logo-whiteColor-zLPH3`
};
module.exports = ___CSS_LOADER_EXPORT___;
